import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=a9be24b6&scoped=true&"
import script from "./Quote.vue?vue&type=script&lang=ts&"
export * from "./Quote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9be24b6",
  null
  
)

export default component.exports